import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApplication96 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3385_184308)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9 15H87V63H9V15Z",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48 61V83",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30 81H66",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18 27H30",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18 39H30",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18 51H30",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42 27H54",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42 39H54",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42 51H54",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66 27H78",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66 39H78",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66 51H78",
				strokeWidth: 4,
				strokeLinejoin: "bevel",
				stroke: "black"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3385_184308",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgApplication96;
